import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fi-eye-icon',
  templateUrl: './eye-icon.component.html',
})
export class EyeIconComponent {
  @Input() height: number | string;
}
